<section class="header">

  <div id="navigation">
    <div class="container-fluid">
      <app-navigation class="in-header"></app-navigation>
    </div>
  </div>
</section>
